import { createStore } from 'zustand';

import { setUserLocationStorage } from '@/storage/location.storage';
import { AutocompletePrediction, Place } from '@/types/google-maps.types';

export type UserLocationStoreState = {
  userLocation: Place | undefined;
  recentSearches: AutocompletePrediction[];
};

export const userLocationStore = createStore<UserLocationStoreState>(() => {
  return {
    userLocation: undefined,
    recentSearches: [],
  };
});

export const setUserLocation = (userLocation: Place) => {
  setUserLocationStorage(userLocation);

  userLocationStore.setState({ userLocation });
};

export const resetUserLocation = () => {
  if (!userLocationStore) {
    return;
  }
  userLocationStore.setState({ userLocation: undefined });
};

export const addRecentSearch = (place: AutocompletePrediction) => {
  userLocationStore.setState((state) => ({
    recentSearches: [
      place,
      ...state.recentSearches.filter((existingPlace) => existingPlace.placeId !== place.placeId),
    ].slice(0, 5),
  }));
};

export const clearRecentSearches = () => {
  if (!userLocationStore) {
    return;
  }
  userLocationStore.setState({ recentSearches: [] });
};
